import PageMain from '../../components/Navigation/PageMain/PageMain';
import GoogleSettings from '../../components/Settings/GoogleSettings/GoogleSettings';

export default function GoogleSettingsPage() {
    return (
        <PageMain pageTitle="Google Settings" showError={false} showLoading={false}>
            <div className="settingsPage">
                <div className="settingsPage__wrapper">
                    <GoogleSettings />
                </div>
            </div>
        </PageMain>
    );
}
